<template>
  <div class="px-3">
    <div v-if="!notFound">
      <div class="flex py-3">
        <div class="flex"> 
          <p class="font-medium text-2xl text-gray-700">{{ $t('message.myTeam.title') }}</p> 
          <zt-tooltip :text="$t('message.myTeam.tooltipInfo')" position="bottom" class="mx-2 pt-2 h-8">
          <zt-icon name="info-cicle-solid" class="text-xl"/>
          </zt-tooltip>
        </div>
        <div class="inline-block m-2 flex justify-end">
          <div class="hover:bg-gray-400 text-red p-2 rounded-l border border-gray-500 cursor-pointer"
          :class="{
              'bg-neutro-600': btnPosition === 'vertical',
              'text-white': btnPosition === 'vertical'
            }" 
           @click="changeOrientation('vertical')" data-vs-button="changeOrientationHorizontal">
            <zt-icon class="text-2xl" name="my-team-horizontal" />
          </div>
          <div class="hover:bg-gray-400 text-red p-2 rounded-r border border-gray-500 cursor-pointer"
          :class="{
              'bg-neutro-600': btnPosition === 'horizontal',
              'text-white': btnPosition === 'horizontal'
            }"
           @click="changeOrientation('horizontal')" data-vs-button="changeOrientationVertical">
            <zt-icon class="text-2xl rotate-icon" name="my-team-horizontal" />
          </div>
        </div>
      </div>
      <div class="container-d3 overflow-auto pb-12">
        <div v-if="btnPosition === 'vertical'">
          <div v-if="teamData.length > 0">
            <verticalChart :teamData="teamData"/>
          </div>
        </div>
        <div v-if="btnPosition === 'horizontal'">
          <div v-if="teamData.length > 0">
            <horizontalChart :teamData="teamData"/>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col md:items-center p-4">
      <p class="font-medium text-2xl text-gray-700 py-4 ">
        {{ $t('message.myTeam.title') }}
      </p>
      <div class="md:flex bg-white rounded p-6 border border-gray-300 ">
        <div class="flex justify-center md:mr-6 mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="104" height="107" fill="none" viewBox="0 0 104 107">
            <path fill="#6C6C6C"
              d="M97.75 63.276c0 .639-.014 1.273-.041 1.904-.568 13.242-7.029 24.959-16.829 32.597C73.464 103.557 64.136 107 54 107c-11.241 0-21.49-4.235-29.238-11.199-5.396-4.847-9.578-11.015-12.039-17.994-1.602-4.548-2.473-9.438-2.473-14.53 0-24.149 19.587-43.725 43.75-43.725 14.663 0 27.64 7.209 35.577 18.272 4.428 6.17 7.29 13.541 8 21.531.114 1.29.173 2.599.173 3.921z" />
            <path fill="#F0EEEE"
              d="M97.579 59.355c-9.266-.357-33.611-2.302-32.96-6.045.933-5.35 27.228-3.025 27.228-6.048s-12.799 0-12.799-4.883c0-2.898 5.325-4.076 10.53-4.556 4.43 6.171 7.29 13.542 8 21.532zM29.652 70.283c0 3.253-10.972 3.203-18.295 2.809-.725-3.155-1.107-6.443-1.107-9.817 0-2.61.229-5.167.668-7.651h.002c6.807.68 13.844 2.23 13.844 5.356 0 4.65-13.496 1.861-13.496 4.65 0 2.792 18.384-.232 18.384 4.653z" />
            <path fill="#A2A0A0"
              d="M80.878 97.775C73.462 103.556 64.134 107 53.998 107c-11.241 0-21.49-4.235-29.237-11.2-.577-.517-1.14-1.05-1.686-1.598-4.586-4.576-8.156-10.162-10.354-16.396l22.14-18.515 16.778 14.032 29.24 24.453z" />
            <path fill="#C8C6C6"
              d="M97.71 65.179c-.568 13.242-7.028 24.958-16.828 32.596-4.483 3.494-9.663 6.134-15.299 7.676-3.689 1.008-7.573 1.547-11.582 1.547-11.24 0-21.49-4.235-29.237-11.198l26.878-22.478 27.902-23.336L97.71 65.179z" />
            <path fill="#C8C6C6"
              d="M80.88 97.775C73.464 103.556 64.135 107 54 107c-11.242 0-21.49-4.235-29.238-11.2-.577-.517-1.14-1.05-1.686-1.598L34.862 59.29 51.64 73.322l29.24 24.453z" />
            <path fill="#A2A0A0"
              d="M79.544 49.986l-13.96 55.465c-3.69 1.008-7.574 1.547-11.583 1.547-11.24 0-21.49-4.235-29.237-11.198l26.878-22.478 27.902-23.336z" />
            <g filter="url(#filter0_ddd)">
              <path fill="#EFEDEE"
                d="M38.8 45.512c7.63-1.048 12.966-8.08 11.917-15.705-1.048-7.625-8.084-12.957-15.714-11.91-7.63 1.049-12.965 8.08-11.917 15.705 1.049 7.626 8.084 12.958 15.714 11.91z" />
            </g>
            <path fill="#3A484A"
              d="M45.184 28.213c-.427.216-.949.045-1.165-.383l-.866-1.712c-.216-.427-.044-.949.383-1.165.427-.215.95-.044 1.165.383l.866 1.713c.216.427.045.948-.383 1.164z" />
            <path fill="#F98084"
              d="M47.252 29.733L45.18 30.78c-.427.216-.949.044-1.165-.383-.216-.427-.044-.949.383-1.165l2.071-1.045c.428-.216.95-.044 1.165.383.216.427.045.948-.383 1.164z" />
            <path fill="#3A484A"
              d="M29.54 36.114c-.428.215-.95.044-1.165-.383l-.866-1.713c-.216-.427-.045-.949.383-1.165.427-.215.949-.044 1.165.383l.866 1.713c.216.428.045.949-.383 1.165z" />
            <path fill="#F98084"
              d="M31.612 37.631l-2.071 1.046c-.428.216-.95.044-1.166-.383-.216-.427-.044-.949.383-1.165l2.071-1.046c.428-.215.95-.044 1.166.383.216.428.044.95-.383 1.165z" />
            <path fill="#3A484A"
              d="M38.352 34.118c-.768.389-1.653.431-2.428.118-.444-.18-.659-.685-.479-1.13.18-.443.686-.657 1.13-.477.31.125.673.104.995-.058.321-.163.554-.442.637-.766.118-.464.59-.744 1.055-.625.464.119.744.59.625 1.055-.207.809-.766 1.495-1.535 1.883z" />
            <defs>
              <filter id="filter0_ddd" width="71.894" height="73.877" x=".955" y=".766" color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dy="7" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dy="5" />
                <feGaussianBlur stdDeviation="11" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                <feOffset dy="12" />
                <feGaussianBlur stdDeviation="8.5" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
                <feBlend in2="effect2_dropShadow" result="effect3_dropShadow" />
                <feBlend in="SourceGraphic" in2="effect3_dropShadow" result="shape" />
              </filter>
            </defs>
          </svg>
        </div>

        <div class="text-center md:text-left">
          <h1 class="text-2xl font-semibold text-gray-700">
            {{ $t('message.myTeam.notFound.title') }}
          </h1>
          <h2 class="text-xl text-gray-700 font-medium py-2">
            {{ $t('message.myTeam.notFound.description') }}
          </h2>
          <p class="text-gray-700 opacity-75">
            {{ $t('message.myTeam.notFound.caption') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Manager from "@/apiClient/Manager"
import horizontalChart from '../components/horizontalChart.vue'
import verticalChart from '../components/verticalChart.vue'

export default {
  name: 'Organigrama',
  components: {
    horizontalChart,
    verticalChart,
},
  data() {
    return {
      notFound: false,
      btnPosition: 'vertical',
      manager: Manager,
      teamData: [],
    }
  },
  async created() {
    this.manager = new Manager
    await this.getMyTeam()
  },
  methods: {
    async getMyTeam() {
      try {
        const result = await this.manager.getMyTeam();
        const { data } = result.data;
        data.length > 0 ? this.teamData=[...data] : this.notFound = true;
      } catch (error) {
        this.teamData = []
      }
    },

    changeOrientation(orientation) {
      this.btnPosition = orientation
    }
  }

}
</script>
<style scoped>
.rotate-icon{
  transform: rotate(-90deg);
}
.bg-neutro-600 {
  background-color: #707070;
}
.container-d3 {
    width: 100%;
    padding: 20px;
    margin-right: auto;
    margin-left: auto;
}

</style>

